'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('adDefaults', {
        url: '/adDefaults',
        template: '<ad-defaults></ad-defaults>'
    });
}



// WEBPACK FOOTER //
// ./client/app/adDefaults/adDefaults.routes.js